import {customizeBrandSvg as Icon__small__customizeBrandSvg} from '../Icon__small/Icon__small--customizeBrand.js';

export var customizeBrand = {
  name: 'customizeBrand',
  category: 'icon',
  colorable: true,
  svg: Icon__small__customizeBrandSvg,
};
